require('./angular-sanitize');
module.exports = 'ngSanitize';



/*****************
 ** WEBPACK FOOTER
 ** /home/live/git/production/project_hagelstamlive/~/angular-sanitize/index.js
 ** module id = 4
 ** module chunks = 0
 **/